var CurrentUser = require("lib/account/CurrentUser");
var Features = require("lib/account/Features");
var Modal = require("components/utility/AltModal");
var Spinner = require("components/utility/Spinner");
var Activity = require("components/writing/activities/Activity");
var StudentActivityInfoLine = require("components/writing/responses/StudentActivityInfoLine");
var ShareResponse = require("components/writing/responses/ShareResponse");
var CommentBox = require("components/social/comments/CommentBox");

require("writing/responses/teacher_view_response_modal.scss");

class TeacherViewResponseModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			responseWithDetails: null
		};
	}

	submitScore(score) {
		var newEvaluation = { score: score, finalized: true };
		var newResponse = _.extend({}, this.state.responseWithDetails, { evaluation: newEvaluation })

		var evaluationData = { admin_score: score,
			grader_id: CurrentUser.get().id,
			response_id: this.state.responseWithDetails.id };

		var updateWithEvaluation = $wr.apiHandler(function(serverResponse) {
			var newResponse = _.extend({}, this.state.responseWithDetails,
				{ evaluation: serverResponse.evaluation, processed: true });
			this.setState({ responseWithDetails: newResponse });
		}.bind(this))

		if (this.state.responseWithDetails.evaluation) {
			var evaluationID = this.state.responseWithDetails.evaluation.id;
			CurrentUser.api().patchEvaluation(evaluationID, { evaluation: evaluationData },
				updateWithEvaluation);

			Mycroft.newEvent({ category: "Response", action: "update-grade", value: score });

		} else {
			CurrentUser.api().postEvaluations({ evaluation: evaluationData },
				updateWithEvaluation);

			Mycroft.newEvent({ category: "Response", action: "submit-grade", value: score });
		}

		this.setState({ responseWithDetails: newResponse });
	}

	archiveResponse() {
		var updateWithProcessedResponse = $wr.apiHandler(function(serverResponse) {
			var newResponse = _.extend({}, this.state.responseWithDetails, { processed: true });
			this.setState({ responseWithDetails: newResponse });
		}.bind(this));

		var data = { response: { processed: true }, activity_id: this.state.responseWithDetails.activity_id };
		CurrentUser.api().patchResponse(this.state.responseWithDetails.id, data,
			updateWithProcessedResponse);

		this.refs.modal.hide();
	}

	show() {
		this.refs.modal.show();
		this.fetchDetails();
	}

	onHide() {
		setTimeout(function() {
			var responseDetails = this.state.responseWithDetails;
			
			this.setState({ responseWithDetails: null }, function() {
				if (this.props.onResponseUpdate) {
					this.props.onResponseUpdate(responseDetails);
				}
			});
		}.bind(this), 200);
	}

	fetchDetails() {
		var embeds = "response.activity,activity.format,response.evaluation,response.input_data,response.input_name,response.activity_data,response.mirror_user_ids,response.text";
		CurrentUser.api().getResponse(this.props.response.id, { embed: embeds }, $wr.apiHandler(function(serverResponse) {
			this.setState({ responseWithDetails: serverResponse.response });
		}.bind(this)));
	}

	render() {
		var response = this.state.responseWithDetails;

		if (response == null) {
			var responseContent = (<div><Spinner placeholder={ true } scale={ 1.7 } /></div>);
		} else {

			if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
				var commentBox = (
					<CommentBox subjectID={ response.id } subjectType="JournalActivityExercise"
						blockFirstComment={ CurrentUser.isStudent() }
						userID={ response.user_id } initialCollapsed={ !CurrentUser.isStudent() } />
				)
			}

			var responseContent = (
				<div>
					<StudentActivityInfoLine response={ response }
						forceEvaluation={ true } user={ this.props.student } />

					<Activity activity={ response.activity }
						response={ response } />

					{ commentBox }

				</div>
			);
			// for now, remove options for sharing collages
			if (response.activity.format.format_class != "CollageFormat") {
				var socialShare = (
					<ShareResponse responseID={ this.props.response.id } />
				);
			}
		}

		return (
			<Modal className="teacherViewResponseModal veryWideModal" onHide={ this.onHide } ref="modal">
				{ responseContent }
				{ socialShare }
			</Modal>
		);
	}
};

TeacherViewResponseModal.propTypes = StrictPropTypes({
	response: PropTypes.object.isRequired,
	student: PropTypes.object.isRequired,
	onResponseUpdate: PropTypes.func
});

module.exports = TeacherViewResponseModal;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/TeacherViewResponseModal.js